import {Route, Routes} from 'react-router-dom'
import './App.css'
import SignIn from './components/SignIn/SignIn';
import RootLayout from './layout/RootLayout'

import {
    Sms,
    SmsDetail,
    AddNewDevice,
    Device,
    DeviceDetail,
    Company,
    AddNewCompany,
    CompanyDetail,
    Version,
    CreateVersion,
    VersionDetail,
    Analysis,
    ZReport,
    ZReportDetail,
    Orders,
    OrderDetail,
    Logs,
    Feedbacks,
    UserProfile,
    Email,
    EmailDetail,
    DeviceRegistrationFirst,
    DeviceRegistrationSecond,
    DeviceReregistrationFirst,
    DeviceReregistrationSecond,
    MainDeviceAnalysis,
    PayMeLogsS2P,
    PayMeLogS2PDetail,
    ClickLogsS2P,
    UzumLogsS2P,
    UzumLogS2PDetail,
    Staffs,
    Tips,
    AuditLogs,
    MarkerMobile,
    MarkerMobileDetail,
    MarkerMobileUpdate,
} from './pages'
import LogsDetail from "./pages/Logs/LogsDetail/LogsDetail";
import ProductDetail from "./pages/Products/ProductDetail/ProductDetail";
import Products from "./pages/Products/Products";
import ClickLogS2PDetail from "./pages/S2PClickLogs/ClickLogsS2PDetail/ClickLogsS2PDetail";
import FboxWikipedia from "./pages/FboxWikipedia/FboxWikipedia";
import {fiscalMeVersionConfig} from './pages/Versions/version.config'

function App() {
    return (
        <div className='App'>
            <Routes>
                <Route path="/" element={<SignIn/>}/>
                <Route path='/device/re/registration/' element={<DeviceReregistrationFirst/>}/>
                <Route path='/device/re/registration/step/2' element={<DeviceReregistrationSecond/>}/>
                <Route path='/device/registration' element={<DeviceRegistrationFirst/>}/>
                <Route path='/device/registration/step/2' element={<DeviceRegistrationSecond/>}/>
                <Route element={<RootLayout/>}>
                    <Route path='/analysis' element={<Analysis/>}/>
                    <Route path='/profile' element={<UserProfile/>}/>
                    <Route path='/devices/company' element={<Company/>}/>
                    <Route path='/devices/version' element={<Version/>}/>
                    <Route path='/create/version/:id?' element={<CreateVersion/>}/>
                    <Route path='/version/detail/:id' element={<VersionDetail/>}/>
                    <Route
                        path='/devices/fiscal-me/version'
                        element={<Version config={fiscalMeVersionConfig}/>}
                    />
                    <Route
                        path='/create/fiscal-me/version/:id?'
                        element={<CreateVersion config={fiscalMeVersionConfig}/>}
                    />
                    <Route
                        path='/fiscal-me/version/detail/:id'
                        element={<VersionDetail config={fiscalMeVersionConfig}/>}
                    />
                    <Route path='/devices' element={<Device/>}/>
                    <Route path='/devices/marker-mobile' element={<MarkerMobile/>}/>
                    <Route path='/devices/marker-mobile/detail/:id' element={<MarkerMobileDetail/>}/>
                    <Route path='/devices/marker-mobile/update/:id' element={<MarkerMobileUpdate/>}/>
                    <Route path='/devices/analysis' element={<MainDeviceAnalysis/>}/>
                    <Route path='/payments/logs' element={<Logs/>}/>
                    <Route path='/s2p/payme/logs' element={<PayMeLogsS2P/>}/>
                    <Route path='/s2p/click/logs' element={<ClickLogsS2P/>}/>
                    <Route path='/s2p/uzum/logs' element={<UzumLogsS2P/>}/>
                    <Route path='/payments/sms' element={<Sms/>}/>
                    <Route path='/email/list' element={<Email/>}/>
                    <Route path='/orders/sale' element={<Orders serialNumber={null} orderType='sale'/>}/>
                    <Route path='/orders/refund' element={<Orders serialNumber={null} orderType='refund'/>}/>
                    <Route path='/orders/prepaid' element={<Orders serialNumber={null} orderType='prepaid'/>}/>
                    <Route path='/orders/credit' element={<Orders serialNumber={null} orderType='credit'/>}/>
                    <Route path='/feedback' element={<Feedbacks/>}/>
                    <Route path='/audit-logs' element={<AuditLogs/>}/>
                    <Route path='/products' element={<Products/>}/>
                    <Route path='/s2p/staffs' element={<Staffs/>}/>
                    <Route path='/s2p/tips' element={<Tips/>}/>

                    <Route path='/create/device/:serial_number?' element={<AddNewDevice/>}/>
                    <Route path='/create_company/:id?' element={<AddNewCompany/>}/>

                    <Route path='/order/detail/:id' element={<OrderDetail/>}/>
                    <Route path='/company/detail/:id' element={<CompanyDetail/>}/>
                    <Route path='/device/detail/:serial_number' element={<DeviceDetail/>}/>
                    <Route path='/payments/logs/detail/:id' element={<LogsDetail/>}/>
                    <Route path='/payments/sms/detail/:id' element={<SmsDetail/>}/>
                    <Route path='/payments/email/detail/:id' element={<EmailDetail/>}/>
                    <Route path='/product/detail/:id' element={<ProductDetail/>}/>
                    <Route path='/s2p/payme/logs/detail/:id' element={<PayMeLogS2PDetail/>}/>
                    <Route path='/s2p/click/logs/detail/:id' element={<ClickLogS2PDetail/>}/>
                    <Route path='/s2p/uzum/logs/detail/:id' element={<UzumLogS2PDetail/>}/>

                    <Route path='/z-reports' element={<ZReport/>}/>
                    <Route path='/z-reports/detail/:id' element={<ZReportDetail/>}/>

                    <Route path='wikipedia' element={<FboxWikipedia/>}/>
                </Route>
            </Routes>
        </div>
    )
}

export default App;
